import {
  getPaymentPlanByExternalId,
  patchUpdateDueDateByPaymentLineId,
  patchUpdatePaymentDateByPaymentLineId,
  patchUpdatePaymentPlanLineQuota,
  patchUpdatePaymentPlanLineStatus,
  PaymentPlan,
  PaymentPlanLine,
  PaymentPlanLineStatus,
} from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const usePaymentPlanLine = (paymentPlan: PaymentPlan, paymentPlanLine: PaymentPlanLine) => {
  const { revalidate: revalidatePaymentPlan } = useCache(getPaymentPlanByExternalId, {
    externalId: paymentPlan.externalId,
  });
  const { request, loading } = useRequest();

  const updateDueDateByPaymentLineId = async (values: { dueDate: Date }) => {
    const dueDate = values.dueDate;
    const year = dueDate.getFullYear();
    const month = String(dueDate.getMonth() + 1).padStart(2, '0');
    const day = String(dueDate.getDate()).padStart(2, '0');
    const formattedDueDate = `${year}-${month}-${day}`;
    await request(patchUpdateDueDateByPaymentLineId, { id: paymentPlanLine.id, dueDate: formattedDueDate });
    revalidatePaymentPlan();
  };

  const updatePaymentDateByPaymentLineId = async (values: { paymentDate: Date }) => {
    await request(patchUpdatePaymentDateByPaymentLineId, {
      id: paymentPlanLine.id,
      paymentDate: values.paymentDate,
    });
    revalidatePaymentPlan();
  };

  const updatePaymentPlanLineQuota = async (values: { amount: string }) => {
    await request(patchUpdatePaymentPlanLineQuota, {
      id: paymentPlanLine.id,
      amount: parseFloat(values.amount),
      currency: paymentPlanLine.quota.currency,
    });
    revalidatePaymentPlan();
  };

  const updatePaymentPlanLineStatus = async (values: { status: PaymentPlanLineStatus }) => {
    await request(patchUpdatePaymentPlanLineStatus, {
      id: paymentPlanLine.id,
      status: values.status,
    });
    revalidatePaymentPlan();
  };

  return {
    updateDueDateByPaymentLineId,
    updatePaymentDateByPaymentLineId,
    updatePaymentPlanLineQuota,
    updatePaymentPlanLineStatus,
    loading,
  };
};
